export { default } from './Fade';